'use client';

import { useEffect } from 'react';
import { useAsPath } from '@/app_lib/hooks/useAsPath';
import { getGtmPageStatusEvent, pushToDataLayer } from './utils';

export const InitPageStatus = () => {
  const asPath = useAsPath();

  // biome-ignore lint/correctness/useExhaustiveDependencies: this is dependent on the path change
  useEffect(() => {
    pushToDataLayer(getGtmPageStatusEvent(false));
  }, [asPath]);

  return null;
};
